import React from "react";
import Dialog from "@mui/material/Dialog";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CloseIcon from "@mui/icons-material/Close";

// Most recently added address: newest createdAt, else highest numeric id,
// else the last one the API returned.
export const latestAddress = (list = []) => {
  if (!list.length) return undefined;
  const score = (o, i) => Date.parse(o?.createdAt) || Number(o?.id) || i;
  return list.reduce((best, o, i) =>
    score(o, i) > score(best, list.indexOf(best)) ? o : best,
  );
};

const oneLineAddress = (a) =>
  [a?.address1, a?.address2, a?.city, a?.state, a?.zipCode, a?.country]
    .filter(Boolean)
    .join(", ");

// Pop-up list of saved addresses. onEdit / onDelete / onAdd are optional;
// their buttons only render when a handler is passed.
const AddressPickerDialog = ({
  open,
  onClose,
  title,
  list,
  selectedId,
  onSelect,
  onEdit,
  onDelete,
  onAdd,
  idPrefix = "address",
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="sm"
    className="address-picker-dialog"
  >
    <div className="address-picker-head">
      <span>{title}</span>
      <button
        type="button"
        className="address-picker-close"
        aria-label="Close"
        onClick={onClose}
      >
        <CloseIcon fontSize="small" />
      </button>
    </div>
    <div className="address-picker-list">
      {list.map((data) => {
        const isSelected = data.id === selectedId;
        const choose = () => {
          onSelect(data);
          onClose();
        };
        return (
          <div
            key={data.id}
            className={`address-picker-item${isSelected ? " is-selected" : ""}`}
            onClick={choose}
          >
            <input
              type="radio"
              checked={isSelected}
              onChange={choose}
              onClick={(e) => e.stopPropagation()}
              id={`${idPrefix}-${data.id}`}
            />
            <div className="address-picker-text">
              <span className="address-picker-name">
                {data.firstName} {data.lastName}
                {data.default && (
                  <span className="address-picker-tag">Default</span>
                )}
              </span>
              <span className="address-picker-line">
                {oneLineAddress(data)}
              </span>
              {data.contactNo && (
                <span className="address-picker-line">{data.contactNo}</span>
              )}
            </div>
            {(onEdit || onDelete) && (
              <div
                className="address-picker-actions"
                onClick={(e) => e.stopPropagation()}
              >
                {onEdit && (
                  <button
                    type="button"
                    aria-label="Edit address"
                    onClick={() => {
                      onClose();
                      onEdit(data);
                    }}
                  >
                    <EditOutlinedIcon fontSize="small" />
                  </button>
                )}
                {onDelete && (
                  <button
                    type="button"
                    aria-label="Delete address"
                    className="is-danger"
                    onClick={() => onDelete(data)}
                  >
                    <DeleteOutlineOutlinedIcon fontSize="small" />
                  </button>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
    {onAdd && (
      <button
        type="button"
        className="address-picker-add"
        onClick={() => {
          onClose();
          onAdd();
        }}
      >
        <AddOutlinedIcon fontSize="small" />
        Add a new address
      </button>
    )}
  </Dialog>
);

export default AddressPickerDialog;
